import { get } from '@/libs/http';
import { type DecayStatusRes, type DetailRes } from '@/types/api/vip/detail.d';
import { createApiQuery } from '@/hooks/use-api-query';
import type { BenefitCustomNicknameRes } from '@/types/api/vip/benefit-custom-nickname';


export const getVipDetail = (): Promise<DetailRes> => {
  return get<DetailRes>('/member/my/v1/detail');
};

export const getBenefitCustomNickname = (): Promise<BenefitCustomNicknameRes> => {
  return get<BenefitCustomNicknameRes>('/member/my/v1/benefit/customNickname');
};
export const useBenefitCustomNickname = createApiQuery(getBenefitCustomNickname, () => []);


export const useGetVipDetail = createApiQuery(getVipDetail, () => ['vip-detail']);


export const getVipStatus = (): Promise<DecayStatusRes> => {
  return get<DecayStatusRes>('/member/my/v1/status');
};